import { createFileRoute } from "@tanstack/react-router";
import CindySandbox from "@/pages/CindySandbox";

const TITLE = "Cindy Chat Sandbox | Rex & Sons RVs";
const DESCRIPTION =
  "Internal testing sandbox for the Cindy chat assistant and live-agent escalation alerts at Rex & Sons RVs.";

export const Route = createFileRoute("/cindy-sandbox")({
  component: CindySandbox,
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:type", content: "website" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
  }),
});
